<template>
  <v-container fluid class="pa-0">
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
      <div
          id="wrapper"
          :data-tf-widget="typeformUrl"
          data-tf-inline-on-mobile
          data-tf-medium="snippet"
          :data-tf-hidden="'id=' + userId"
          style="height: calc(100vh - 88px - 36px);"
      ></div>
    
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import maxios from "@/services/mediligo-axios";

export default {
  i18n: i18n,
  name: "m2h-survey",
  props: ['typeformUrl', 'survey'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      emailChecked: false,
      userId: '',
      hasError: false,
    }
  },
  mounted() {
    this.checkEmail()
  },


  methods: {
    async checkEmail() {
      const res = await maxios.get( `/api/survey/user/exists?survey=${this.survey}`);
      if (!res.data){
        this.hasError = true
      } else {
        this.emailChecked = true
        this.userId = res.data.identifier;
        let embedScript = document.createElement('script')
        embedScript.setAttribute('src', '//embed.typeform.com/next/embed.js')
        document.head.appendChild(embedScript)
        await this.logSurveyOpened()
      }
    },
    
    async logSurveyOpened() {
      this.$root.$emit('post-survey-opened')
    },
  },
}
</script>

<style scoped>
</style>
